import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import CitizenIdModal from '../modals/CitizenIdModal';
import * as action from '../action';
import * as c from '../constant';

import CmsContext from '../../../context/CmsContext';

function CitizenContent({
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  // onApprove,
  taxpayer,
  approveTransaction,
  rejectTransaction,
  // onTagAsPrinted,
  // taggingAsPrinted,
  // assessting,
  approving,
  rejecting,
  permissions,
}) {
  const cmsContext = useContext(CmsContext)
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const isEmployed = _.get(taxpayer, 'attributes.is_employed_individual');

  const handleViewId = (data) => (e) => {
    e.preventDefault();
    setModal({
      title: `${_.get(CMS_VARIABLES, 'CITIZEN_ID')}`,
      isOpen: true,
      content: <CitizenIdModal profile={data} />,
      modalSize: 'modal-lg',
    });
  };

  const handleOnApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to APPROVE this application?',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            official_residency_application_remarks: remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleOnReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to REJECT this application?',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            official_residency_application_remarks: remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayer, 'attributes.photo') !==
                          '-/format/jpeg/' ? (
                            <img
                              alt="Client Profile"
                              src={_.get(taxpayer, 'attributes.photo')}
                            />
                        ) : (
                          getInitials(
                            `${_.get(
                              taxpayer,
                              'attributes.first_name'
                            )} ${_.get(taxpayer, 'middle_name')} ${_.get(
                              taxpayer,
                              'attributes.last_name'
                            )}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'attributes.first_name') || '-'} ${_.get(taxpayer, 'attributes.middle_name') || ''
                          } ${_.get(taxpayer, 'attributes.last_name') || ''} ${_.get(taxpayer, 'attributes.extension_name') || ''
                          }`}
                      </h1>
                    </div>
                    {_.get(
                      taxpayer,
                      'attributes.official_residency_application_status'
                    ) === 'APPROVED' && (
                      <div className="d-flex ml-auto">
                        <button
                          onClick={handleViewId(taxpayer)}
                          type="button"
                          className="btn btn-success btn-round font-weight-bold mr-1"
                        >
                          View ID
                        </button>
                      </div>
                    )}
                    {_.get(
                      taxpayer,
                      'attributes.official_residency_application_status'
                    ) !== 'APPROVED' && Acl(permissions, ['APPROVE OR REJECT CITIZEN']) && (
                      <div className="d-flex ml-auto">
                        <button
                          style={{ width: '100px' }}
                          disabled={approving}
                          onClick={handleOnApprove(taxpayer)}
                          className="btn btn-success btn-round font-weight-bold mr-1"
                          type="button"
                        >
                          {approving ? (
                            <>
                              <i className="fa fa-spin fa-spinner" /> &nbsp;
                              <>Approve</>
                            </>
                          ) : (
                            <>Approve</>
                          )}
                        </button>
                        <button
                          style={{ width: '100px' }}
                          disabled={rejecting}
                          onClick={handleOnReject(taxpayer)}
                          className="btn btn-danger btn-round font-weight-bold mr-1"
                          type="button"
                        >
                          {rejecting ? (
                            <>
                              <i className="fa fa-spin fa-spinner" /> &nbsp;
                              <>Reject</>
                            </>
                          ) : (
                            <>Reject</>
                          )}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-1 pb-1 px-3">
            <div className="col-12">
              <table className="transaction-table table table-borderless table-sm table-striped table-hover">
                <tbody>
                  <tr>
                    <td className="text-dark" width="250">
                      Residency Status
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            taxpayer,
                            'attributes.official_residency_application_status'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Resident ID
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {_.get(
                          taxpayer,
                          'attributes.official_resident_id_number'
                        ) || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Residency Application Remarks
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            taxpayer,
                            'attributes.official_residency_application_remarks'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.last_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.middle_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.first_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Extension Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.extension_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Address
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {_.get(taxpayer, 'attributes.region_name') || '--'}
                        {''}
                        {_.get(taxpayer, 'attributes.province_name') ||
                          '--'}{' '}
                        {_.get(taxpayer, 'attributes.municipality_name') ||
                          '--'}{' '}
                        {_.get(taxpayer, 'attributes.barangay_name') || '--'}{' '}
                        {_.get(taxpayer, 'attributes.street') || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Is Employed
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{isEmployed ? 'YES' : 'NO'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Gender
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.gender') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Civil Status
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.civil_status') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Citizenship
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.citizenship_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      ACR No. (if alien)
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.acr_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Place of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            taxpayer,
                            'attributes.place_of_birth_region_name'
                          ) || '--'
                        ).toUpperCase()}{' '}
                        {(
                          _.get(
                            taxpayer,
                            'attributes.place_of_birth_province_name'
                          ) || '--'
                        ).toUpperCase()}{' '}
                        {(
                          _.get(
                            taxpayer,
                            'attributes.place_of_birth_municipality_name'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Date of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(taxpayer, 'attributes.birth_date') || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Profession/Occupation Business
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.profession_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Height
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.height') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Weight
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.weight') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Proof of Identification
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <img
                        style={{
                          maxWidth: '500px',
                          width: '100%',
                          margin: '0 auto',
                        }}
                        alt="proof of residency"
                        src={_.get(
                          taxpayer,
                          'attributes.proof_of_residency_url'
                        )}
                      />
                    </td>
                  </tr>
                  {Acl(permissions, ['GENERATE USERNAME AND PIN']) && (
                    <>
                      <tr>
                        <td className="text-dark" width="250">
                          Username
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td>
                          <b>
                            {(
                              _.get(taxpayer, 'attributes.user_id') || '--'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Pin
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td>
                          <b>
                            {(
                              _.get(taxpayer, 'attributes.login_pin') || '--'
                            )}
                          </b>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

CitizenContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  // transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,
  // onTagAsPrinted: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  // transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item`) || {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  approving: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
  rejecting: api.loading.indexOf(c.REJECT_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(CitizenContent);
